import React from "react";

import Header from "../components/Header";
import Footer from "../components/Footer";
import GlobalCta from "../components/global/GlobalCta";
import PageHero from "../components/global/PageHero";
import WorkGallery from "../components/work/WorkGallery";

export default function Portfolio() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Our work" title="Real products for real businesses.">
                    A selection of custom builds, platforms and sites we've shipped across industries.
                </PageHero>

                <WorkGallery />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
